<template>
    <div class="subView">
        <div class="subView_list">
            <div class="subView_item">
                <div class="title">{{navList.parentText}}<span style="border: 2px solid #CCCBDB;font-size: 20px;position: relative;top: -4px;margin-left: 20px"></span>
                    <span class="text" style="margin-left: 10px">
                    {{navList.columnText}}</span>
                </div>
                <div class="btnBox">
                    <el-button class="btn" @click="goabout()">免费咨询</el-button>
                </div>
            </div>
<!--            <div class="box-left">-->
<!--                <saasNav></saasNav>-->
<!--            </div>-->
            <div class="box-right">
                <div class="subView_top" v-for="item in navList.list" :key="item.index">

                    <div class="top-title">
                        <p class="title">{{item.columnText}}</p>
                        <div class="border"></div>
                    </div>
                    <div class="font-p" v-if="item.remark == '1'">
                        <p v-for="item2 in item.list" style="line-height: 30px" :key="item2.index">{{item2.columnText}}</p>
                    </div>
                    <div class="font-p" v-if="item.remark == '2'" style="margin-top: 39px">
                        <img :src="item.list[0].columnImg" width="98%" alt="">
                    </div>
                    <el-row class="font-p" v-if="item.remark == '3'" style="margin-top: 39px">
                       <el-col :span="4" v-for="item3 in item.list" style="margin-right:10px" :key="item3.index">
                           <div class="item_img" >
                               <img class="img-tp" :src="item3.columnImg" width="100%" alt="">
                           </div>
                           <div class="item_text center blue" style="text-align: center">
                               {{item3.columnText}}
                           </div>
                       </el-col>
                    </el-row>
                </div>
<!--                <div class="subView_center">-->
<!--                    <div class="top-title">-->
<!--                        <p class="title">{{navList.list[1].columnText}}</p>-->
<!--                        <div class="border"></div>-->
<!--                    </div>-->
<!--                    <div class="list">-->
<!--                        <div class="item">-->
<!--                            <div class="item_img">-->
<!--                                <img class="img-tp" src="../../assets/mtevidence/page6.png" alt="">-->
<!--                            </div>-->
<!--                            <div class="item_text center blue">-->
<!--                                数据确认-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="item">-->
<!--                            <div class="item_img">-->
<!--                                <img src="../../assets/mtevidence/page5.png">-->
<!--                            </div>-->
<!--                            <div class="item_text center blue">-->
<!--                                可靠存证-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="item">-->
<!--                            <div class="item_img">-->
<!--                                <img src="../../assets/mtevidence/page1.png" alt="">-->
<!--                            </div>-->
<!--                            <div class="item_text center blue">-->
<!--                                全网检测-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="item">-->
<!--                            <div class="item_img">-->
<!--                                <img src="../../assets/mtevidence/page2.png" alt="">-->
<!--                            </div>-->
<!--                            <div class="item_text center blue">-->
<!--                                可信身份-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="item">-->
<!--                            <div class="item_img">-->
<!--                                <img src="../../assets/mtevidence/page3.png" alt="">-->
<!--                            </div>-->
<!--                            <div class="item_text center blue">-->
<!--                                数据不可篡改-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="item">-->
<!--                            <div class="item_img">-->
<!--                                <img src="../../assets/mtevidence/page4.png" alt="">-->
<!--                            </div>-->
<!--                            <div class="item_text center blue">-->
<!--                                司法有效-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="subView_foot">-->
<!--                    <div class="top-title">-->
<!--                        <p class="title">业务流程</p>-->
<!--                        <div class="border"></div>-->
<!--                    </div>-->
<!--                    <div class="img">-->
<!--                        <img src="../../assets/mtevidence/saas_img_1.png" alt="">-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import saasNav from '../mtevidence/saas-nav.vue'
    export default {
        name: "mtevidence-app",
        components:{saasNav},
        data(){
            return{
                navList:{},
            }
        },
        created(){
             this.getDataList()
        },
        methods:{
          goabout(){
            this.$router.push({
              name: 'about-app'
            })
          },
            getDataList() {
                if(this.$route.query.text){}else{
                    axios.post("https://article.chenhaninfo.com/publish-article/sys/column/columnList", {
                    }).then(({data}) => {
                        if (data && data.code === 0) {
                            for(let item of data.list){
                                if(item.columnText == '解决方案'){
                                    axios.get("https://article.chenhaninfo.com/publish-article/sys/column/byName?text=" + item.list[0].list[0].columnText, {
                                    }).then(({data}) => {
                                        if (data && data.code === 0) {
                                            this.navList = data.list[0];
                                        }
                                    }).catch(function (error) {
                                        console.log(error);
                                    })
                                }
                            }
                        } else {
                            this.navList = {}
                        }
                    }).catch(function (error) {
                        console.log(error);
                    })
                }

            },
        },
        watch: {
            $route:{
                immediate:true,
                handler(){
                    if(this.$route.query.text){//需要监听的参数
                        axios.get("https://article.chenhaninfo.com/publish-article/sys/column/byName?text=" + this.$route.query.text, {
                        }).then(({data}) => {
                            if (data && data.code === 0) {
                                this.navList = data.list[0];
                            }
                        }).catch(function (error) {
                            console.log(error);
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .subView {
        margin-top: 78px;
        background-color: #fff;
        // min-width: 1580px;
        width: 100%;
        .subView_list {

            .subView_item {
                background-image: url("../../assets/beijing.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                width: 100%;
                height: 200px;
                text-align: center;

                .title {
                    font-size: 20px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #282B31;
                    padding-top: 50px;

                    .text {
                        font-size: 20px;
                        font-weight: 500;
                        color: #2D3036;
                    }
                }

                .btnBox {
                    margin-top: 32px;
                }

                .btn {
                    width: 125px;
                    height: 39px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    // line-height: 16px;
                    background: #0069FD;
                    border-radius: 20px;
                }
            }
            .box-left{
                margin-left: 15%;
                width: 30%;
            }
            .box-right{
                margin-left: 5%;
                // width: 80%;
                padding-bottom: 80px;
                min-height: 220px;
            }
            .subView_top{
                // text-align: left;
                // margin-top: 50px;
                width: 100%;
                // margin-right: 20%;
                .top-title {
                    padding-top: 50px;

                    .title {
                        font-size: 18px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #282F3C;
                        margin-left: 4px;
                    }

                    .border {
                        width: 80px;
                        height: 3px;
                        margin-top: 3px;
                        background-color: #056DFF;
                    }
                }
                .font-p p{
                    /*min-width: 1010px;*/
                    // height: 150px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #353F52;
                    /*line-height: 80px;*/
                    margin-top: 30px;
                    margin-right: 20px;
                }
            }
            .subView_center{
                text-align: left;
                width: 60%;
                margin-left: 20%;
                .top-title {
                    padding-top: 82px;
                    .title {
                        font-size: 18px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #282F3C;
                        margin-left: 4px;
                    }

                    .border {
                        width: 27px;
                        height: 3px;
                        margin-top: 3px;
                        background-color: #056DFF;
                    }
                }
                .list {
                    display: flex;
                    width: 100%;
                    .item {
                        /* margin-right: 6%; */
                        flex: 1;

                        &:last-child {
                            margin-right: 0;
                        }

                        .item_img {
                            padding: 20px;
                            text-align: left;
                            margin-top: 61px;
                        }

                        .item_img img {
                            /*width: 106px;*/
                            /*height: 106px;*/
                        }
                        .item_name {
                            text-align: center;
                            font-size: 24px;
                            color: #2A67E3;
                            padding: 20px 0px;
                            height: 102px;
                        }
                        .item_text {
                            width: 84px;
                            height: 20px;
                            font-size: 14px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #282F3C;
                            line-height: 20px;
                            text-align: center;
                            margin-left: 10px;
                        }
                    }
                }

            }
            .subView_foot{
                text-align: left;
                width: 60%;
                margin-left: 20%;
                .top-title {
                    padding-top: 82px;

                    .title {
                        font-size: 18px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #282F3C;
                        margin-left: 4px;
                    }

                    .border {
                        width: 27px;
                        height: 3px;
                        margin-top: 3px;
                        background-color: #056DFF;
                    }
                }
                img{
                    width: 100%;
                    height: 127px;
                    background: #FAFBFC;
                    border-radius: 5px;
                    margin-top: 84px;
                    margin-bottom: 89px;
                }
            }
        }
    }
</style>
